import React, { useEffect, useState } from "react";

function formatSeoulTime(d) {
  const fmt = new Intl.DateTimeFormat("en-GB", {
    timeZone: "Asia/Seoul",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  });
  return fmt.format(d);
}

export default function SeoulClock({ className = "" }) {
  const [time, setTime] = useState(() => formatSeoulTime(new Date()));
  useEffect(() => {
    const i = setInterval(() => setTime(formatSeoulTime(new Date())), 1000);
    return () => clearInterval(i);
  }, []);
  return (
    <div data-testid="seoul-clock" className={`inline-flex items-center gap-2 ${className}`}>
      <span className="relative flex h-2 w-2">
        <span className="absolute inline-flex h-full w-full rounded-full bg-[#34D399] opacity-75 animate-ping" />
        <span className="relative inline-flex rounded-full h-2 w-2 bg-[#34D399]" />
      </span>
      <span className="font-display text-xs tracking-[0.2em] uppercase">Seoul · {time}</span>
    </div>
  );
}
